import * as React from 'react';

const ChevronDownSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="chevron-down_svg__eds-icon--down-chevron_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M18.3 8L12 14.3 5.7 8l-.7.7 7 7 7-7z"
        />
    </svg>
);

ChevronDownSvg.displayName = 'ChevronDownSvg';
export default ChevronDownSvg;
